module.exports = __webpack_public_path__ + "static/media/front.d494e0b4.jpg";